import CMSService from 'services/CMS/';

const actions = {
    getPage(id, cache = "newHome") {
        return Promise.all([
            CMSService.getDateTime(),
            CMSService.getHome(id, cache, 'cms')
        ]).then(results => {
            let result = {
                datetime: null,
                acf: null
            };
            let content = results[1];
            result.datetime = results[0].datetime;
            result.acf = content && content.acf ? content.acf : null;
            return result;
        }).catch(()=>{
            return false;
        });
    },
    getPostType(type, slug, fullContent = false){
        return Promise.all([
            CMSService.getDateTime(),
            CMSService.getPostType(slug, type)
        ]).then(results => {
            let result = {
                datetime: null,
                acf: null
            };
            let content = results[1];

            result.datetime = results[0].datetime;

            if(fullContent) {
                result.acf = content;
            } else {
                result.acf = content && content.acf ? content.acf : null;
            }
            return result;
        }).catch(()=>{
            return false;
        });
    },
    getPageSchool(id, cache = 'school'){
        return Promise.all([
            CMSService.getDateTime(),
            CMSService.getSchool(id, cache)
        ]).then(results => {
            let result = {
                datetime: null,
                acf: null
            };
            let content = results[1];
            result.datetime = results[0].datetime;
            result.acf = content && content.acf ? content.acf : null;
            return result;
        }).catch(()=>{
            return false;
        });
    }
};

export default actions;
